import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { SKIP_LOADER_HEADER } from '@siat-fe/core';
import { environment } from '@siat-fe/env';
import { Observable } from 'rxjs';
import { TicketSupportoDTO } from '../models/ticket-supporto.model';

@Injectable({
  providedIn: 'root',
})
export class SupportoService {
  /**
   * Http client used to call the help desk API.
   */
  private readonly http = inject(HttpClient);

  /**
   * The help desk ticket endpoint.
   */
  private readonly ticketUrl = `${environment.baseUrl}v1/hd/ticket`;

  /**
   * Opens a help desk ticket sending the report with its base64 attachments.
   * Skips the global loader, which would stay hidden behind the dialog: the
   * dialog shows its own spinner.
   * @returns {Observable<unknown>} The ticket creation response
   */
  createTicket(report: TicketSupportoDTO): Observable<unknown> {
    return this.http.post(this.ticketUrl, report, {
      headers: new HttpHeaders({ [SKIP_LOADER_HEADER]: 'true' }),
    });
  }
}
